import React from 'react';

import { Banner } from './component/Banner';

/**
 * Displays a bottom banner encouraging petition starters to download the Change.org mobile app.
 * The banner is only shown to users who own the petition and when the feature is enabled.
 */
export const AppDownloadBottomBanner: React.FC<AppDownloadBottomBannerProps> = ({
	enabled,
	androidEnabled,
	ownPetition,
	sourceLocation,
}) => {
	if (!ownPetition) return null;

	return <Banner sourceLocation={sourceLocation} enabled={enabled} androidEnabled={androidEnabled} />;
};

type AppDownloadBottomBannerProps = {
	/** Whether the banner feature is enabled (typically controlled by an experiment). */
	enabled: boolean;

	/** Whether the Android banner variant is enabled (controlled by mobile_app_download_android_banner experiment). */
	androidEnabled: boolean;

	/** Whether the current user owns the petition being viewed. */
	ownPetition: boolean;

	/** The location identifier for tracking where the banner is displayed (e.g., "petition_dashboard"). */
	sourceLocation: string;
};
